import type { LeadFormData } from "../types";

interface Props {
  data: LeadFormData;
  onBooked: (booking: NonNullable<LeadFormData["booking"]>) => void;
}

function capitalize(name: string) {
  if (!name) return name;
  return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function StepConfirmation({ data, onBooked: _onBooked }: Props) {
  const rawFirst = data.fullName?.trim().split(/\s+/)[0] || "there";
  const firstName = capitalize(rawFirst);
  const businessName = data.businessName?.trim() || "your business";

  return (
    <div className="space-y-6">
      <div className="space-y-3">
        <h2 className="text-balance text-3xl font-bold tracking-tighter text-foreground sm:text-4xl">
          Wait, {firstName} - you're not done yet!
        </h2>
        <p className="text-base text-muted-foreground">
          To claim your <span className="font-semibold text-foreground">Free Custom Mockup</span> for{" "}
          <span className="rounded bg-brand-blue/15 px-1.5 py-0.5 font-semibold text-foreground">
            {businessName}
          </span>
          , book a quick time so we can walk you through it live.
        </p>
      </div>
    </div>
  );
}
